export default (link: string) => {
  window.history.pushState({ idx: window.history.state?.idx + 1 || 0 }, '', link)
}
